var _rect, _path, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlans(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "#22292F",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 16.125C10 15.6418 10.3918 15.25 10.875 15.25H16.625C17.1082 15.25 17.5 15.6418 17.5 16.125C17.5 16.6082 17.1082 17 16.625 17H10.875C10.3918 17 10 16.6082 10 16.125ZM10 12.125C10 11.6418 10.3918 11.25 10.875 11.25H16.625C17.1082 11.25 17.5 11.6418 17.5 12.125C17.5 12.6082 17.1082 13 16.625 13H10.875C10.3918 13 10 12.6082 10 12.125ZM10 8.125C10 7.64175 10.3918 7.25 10.875 7.25H16.625C17.1082 7.25 17.5 7.64175 17.5 8.125C17.5 8.60825 17.1082 9 16.625 9H10.875C10.3918 9 10 8.60825 10 8.125Z",
    fill: "#22292F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.625,
    cy: 8.125,
    r: 1.125,
    fill: "#22292F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.625,
    cy: 16.125,
    r: 1.125,
    fill: "#22292F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.625,
    cy: 12.125,
    r: 1.125,
    fill: "#22292F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlans);
export default __webpack_public_path__ + "static/media/plans.75da41cdd53a13b1a01d9f4d9788a943.svg";
export { ForwardRef as ReactComponent };